import axios from 'axios';

import { AUCTION_MAKE_AN_OFFER_ENDPOINT } from '../consts';

export const auctionMakeAnOfferRequest = ({
  entityId,
  csrfToken,
  values,
  onResponse,
  onError,
}) => {
  const payload = { entity_id: entityId, values };

  axios
    .post(AUCTION_MAKE_AN_OFFER_ENDPOINT, payload, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
    })
    .then(onResponse)
    .catch(onError);
};
